import React, { Component } from 'react';
import { withStyles } 		from 'material-ui/styles';
import Avatar 				from 'material-ui/Avatar';

const styles = {
  avatar: {
    margin: 10,
  },
  row: {
    display: 'flex',
    justifyContent: 'center',
  },
};

class LetterAvatar extends Component {
  classes = this.props.classes;
  render() {
    return (
    <div className={this.classes.row}>
        <Avatar className={this.classes.avatar}>{this.props.name.charAt(0)}</Avatar>
    </div>
    );
  }
}

export default withStyles(styles)(LetterAvatar);



// WEBPACK FOOTER //
// ./src/components/auth/LetterAvatar.js